module.exports = {
      id: "symbol-arrow-dots-play-100-usage",
      viewBox: "0 0 100 60",
      url: __webpack_public_path__ + "media/sprite.9e429753.svg#symbol-arrow-dots-play-100-usage",
      toString: function () {
        return this.url;
      }
    }